<template>
  <lm-modal-tour
    :ref="modalName"
    :name="modalName"
    :data="data"
    class="ModalInterfaceTour"
  />
</template>

<script>
import {Modal} from '@/lib/definitions'
import LmModalTour from '@/components/ui/LmModalTour'

export default {
  name: 'ModalInterfaceTour',
  components: {
    LmModalTour
  },
  data() {
    return {
      modalName: Modal.INTERFACE_TOUR,
      data: [
        {
          title: 'Quick access to everywhere',
          description: `The <i>Menu button</i> <img
          src="/img/icons/menu_black_24dp.png"
          alt="Create Landscape illustration"
          class="inline"
        /> is always accessible in the top right hand corner. Use it to open the <i>Sidenav</i> and navigate quickly to your Landscapes, settings and more.`,
          img: `/img/onboarding/menu-access.png`
        },
        {
          title: 'Configure your account',
          description: `Update here your profile, manage your subscription<br>
and configure global options.`,
          img: `/img/onboarding/sidenav-account-settings.png`
        },
        {
          title: 'We are here to help!',
          description: `Questions, feedback, bug reports...<br>use our Contact form and we will answer you ASAP.`,
          img: `/img/onboarding/sidenav-support.png`
        },
        {
          title: 'Your Landscapes, at one click',
          description: `All of your Landscapes are accessible in the Sidenav.<br>
Mark them as favorite for quick access. `,
          img: `/img/onboarding/sidenav-landscapes.png`
        }
      ]
    }
  }
}
</script>
